import { AppMultiAccountModule as AppModule } from '../../../../app-multi-account.module';
import { AdobeLaunchService } from '../../../../services/adobe-launch/adobe-launch.service';

type Constructor = new (...args: unknown[]) => object;
function AdobeTagging(configData: Record<string, Array<{ method: string; data: unknown[] }>>) {
    return function <T extends Constructor>(constructor: T) {
        Object.keys(configData).forEach((methodName) => {
            const methodData = configData[methodName];
            const originalMethod = constructor.prototype[methodName];

            constructor.prototype[methodName] = function (...args: unknown[]) {
                if (originalMethod && typeof originalMethod === 'function') {
                    originalMethod.apply(this, args);
                }
                const adobeLaunchService =
                    AppModule.injector.get<AdobeLaunchService>(AdobeLaunchService);
                methodData.map((data) => {
                    adobeLaunchService[data.method].apply(adobeLaunchService, data.data);
                });
            };
        });
    };
}

export default AdobeTagging;
